import React from "react";
import Header from "../../components/HeaderNew";
import { Button } from "@material-ui/core";
import Footer from "../FooterNew";
import EndStep from "../../image/new/blockdev/end-end.webp";
import { Helmet } from "react-helmet";

import { Section } from "react-scroll-section";
import NewHead from "../landing/NewHead";
import ServiceFooter from "../ServiceFooter";



function Cex() {
 

  return (
    <div className="Blockchain_txtcontent blockchain_dev">
      <header className="newpage  blog_page">
        {/* <Header /> */}
        <NewHead />
      </header>
      <div className="paddin_immner">
        <main className=" carer_page">
          <span>
            <Helmet>
              <title>
                Enterprise Blockchain Development Company | Beleaf Technology
              </title>
              <link
                rel="canonical"
                href="https://beleaftechnologies.com/enterprise-blockchain-development-company"
              />
              <meta
                name="title"
                content=" Enterprise Blockchain Development Company | Beleaf Technology "
              />
              <meta
                name="description"
                content="Utilize blockchain technology to create a strong and
                secure network of blockchain apps for industries and
                businesses."
              />
              <meta
                name="keywords"
                content="blockchain software development, blockchain software development company, Blockchain Development Services, blockchain technology companies, Blockchain Development Company, blockchain software companies, blockchain app development company, top blockchain development companies, best blockchain development company
                    "
              />
              <meta
                property="og:title"
                content=" Enterprise Blockchain Development Company | Beleaf Technology "
              />
              <meta property="og:site_name" content="Beleaf Technologies" />
              <meta
                property="og:url"
                content="https://beleaftechnologies.com/enterprise-blockchain-development-company"
              />
              <meta
                property="og:description"
                content="Utilize blockchain technology to create a strong and
                secure network of blockchain apps for industries and
                businesses."
              />
              <meta property="og:type" content="website" />

              <meta name="twitter:card" content="summary" />
              <meta name="twitter:site" content="@BeleafTech" />
              <meta
                name="twitter:title"
                content=" Enterprise Blockchain Development Company | Beleaf Technology "
              />
              <meta
                name="twitter:description"
                content="Utilize blockchain technology to create a strong and
                secure network of blockchain apps for industries and
                businesses."
              />

              <meta name="twitter:image:alt" content="Beleaf Technologies" />
            </Helmet>

            <div className="ourserveic_banner ourserveic_bannernft   bg_blokcdd">
              {/* <div className="bg-overlay"></div> */}
              <div className="container">
                <div className="row">
                  <div className="col-lg-10">
                    <div className="service_content">
                      <h1 className="font_sizede">
                        Enterprise Blockchain Development Company
                      </h1>
                      <p>
                        Utilize blockchain technology to create a strong and
                        secure network of blockchain apps for industries and
                        businesses.
                      </p>
                      <Button
                        data-toggle="modal"
                        data-target="#myModal"
                        className="box_shadow_non"
                        aria-label="Construct Your Blockchain"
                      >
                        Construct Your Blockchain
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <section className="section bg-white bg_block_cjahina">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="first_section_crypto">
                      <h2 className="text_ceeenter">
                        Enterprise Blockchain Development Company
                      </h2>
                      <p className="text-center">
                        As a prominent blockchain development firm, Beleaf
                        technology delivers enterprise-scale blockchain
                        solutions and is concerned with the digital expansion of
                        organizations, startups, and sectors in the blockchain
                        area. In our custom blockchain development services, we
                        investigate, experiment, and adapt emerging blockchain
                        technology across 25+ sectors and 100+ regions. Join us
                        and work with our 150+ skilled developers to create
                        next-generation blockchain apps.
                      </p>
                      <div className="button_CTA_block">
                        {/* <Button data-toggle="modal" data-target="#myModal">
                          Catch Our Experts
                        </Button> */}
                        <a href="https://wa.me/7904323274" target="_blank">
                          Connect Us Via Whatsapp
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="first_section_crypto padint_amubae">
                      <h2 className="">
                        Significance of Blockchain for Enterprises
                      </h2>
                      <p className="">
                        Blockchain facilitates the verification and traceability
                        of multistep transactions that need verification and
                        traceability. It may ensure safe transactions, lower
                        compliance expenses, and accelerate data transfer
                        processes. Blockchain technology can aid in contract
                        administration and product auditing.
                      </p>
                      <Button
                        data-toggle="modal"
                        data-target="#myModal"
                        aria-label="Request For A Quote"
                      >
                        Request For A Quote
                      </Button>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="option_section">
                      <ul>
                        <li>
                          <div>
                            <img
                              src={require("../../image/new/blockdev/decentralized.webp")}
                              alt="techstack"
                              className=""
                            />
                          </div>
                          <div className="space_pading">
                            <h3>Decentralization</h3>
                            <p>
                              The distributed ledger facilitates the sharing of
                              records among business network participants. This
                              eliminates the need for separate ledgers to agree.
                            </p>
                          </div>
                        </li>
                        <li>
                          <div>
                            <img
                              src={require("../../image/new/blockdev/save-money.webp")}
                              alt="techstack"
                              className=""
                            />
                          </div>
                          <div className="space_pading">
                            <h3>Saves Money</h3>
                            <p>
                              It allows your company to maximize profits by
                              utilizing blockchain technology. It will cut your
                              payment in half and protect you against structural
                              costs.
                            </p>
                          </div>
                        </li>
                        <li>
                          <div>
                            <img
                              src={require("../../image/new/blockdev/access.webp")}
                              alt="techstack"
                              className=""
                            />
                          </div>
                          <div className="space_pading">
                            <h3>Authorization</h3>
                            <p>
                              Several members of the blockchain networks have
                              access to rights to examine data that may be
                              exchanged among them with a need in order to
                              understand the foundation of the company's
                              demands.
                            </p>
                          </div>
                        </li>
                        <li>
                          <div>
                            <img
                              src={require("../../image/new/blockdev/phoenix.webp")}
                              alt="techstack"
                              className=""
                            />
                          </div>
                          <div className="space_pading">
                            <h3>Imperishable</h3>
                            <p>
                              It necessitates an agreement for those members
                              discovered on the blockchain network. Furthermore,
                              the exchange transactions are meticulously
                              documented. It is advantageous since even system
                              administrators are unable to cut out the
                              transactions.
                            </p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-buble">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="first_section_crypto ">
                      <h2 className="text_ceeenter">
                        Our Blockchain Development Services
                      </h2>
                      <p className="text-center">
                        Begin your adventure in the blockchain development
                        sector. Blockchain development services <br />
                        aid in the creation of decentralized apps that improve
                        data and transaction traceability and security.
                      </p>
                    </div>
                    <ul className="row list_item_d justify-content-center">
                      <li className="col-lg-6">
                        <div className="dtatas">
                          <span>1</span>
                          <div>
                            <h3>Blockchain Technology Consulting</h3>
                            <p>
                              Our blockchain consulting methodology begins with
                              what, why, and how blockchain technology may
                              enhance your enterprise solution and increase
                              trust and transparency.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-lg-6">
                        <div className="dtatas">
                          <span>2</span>
                          <div>
                            <h3>Development of a Blockchain Protocol</h3>
                            <p>
                              Helping enterprise and start-up firms comprehend,
                              strategize, and develop blockchain protocols
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-lg-6">
                        <div className="dtatas">
                          <span>3</span>
                          <div>
                            <h3>dApps Development</h3>
                            <p>
                              From planning to design and development, our
                              blockchain developers create enterprise-grade
                              decentralized apps to help customers reduce time
                              to market and optimize ROI.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-lg-6">
                        <div className="dtatas">
                          <span>4</span>
                          <div>
                            <h3>NFT Marketplace Development</h3>
                            <p>
                              Providing simple-to-use, transparent, and
                              feature-rich NFT markets for buying, selling,
                              bidding, and minting multi-chain compatible NFTs.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-lg-6">
                        <div className="dtatas">
                          <span>5</span>
                          <div>
                            <h3>Metaverse Development</h3>
                            <p>
                              Helping you construct your own metaverse by
                              meeting technical and development demands with an
                              interactive virtual and artificial place.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-lg-6">
                        <div className="dtatas">
                          <span>6</span>
                          <div>
                            <h3>Cryptocurrency Exchange</h3>
                            <p>
                              Providing exchange platforms that are safe,
                              immutable, and simple to use, as well as effective
                              real-time trading systems for digital assets.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-lg-6">
                        <div className="dtatas">
                          <span>7</span>
                          <div>
                            <h3>Smart Contract Development</h3>
                            <p>
                              enabling organizations to automate activity
                              execution while maintaining the integrity of
                              multi-party agreements.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-lg-6">
                        <div className="dtatas">
                          <span>8</span>
                          <div>
                            <h3>Smart Contract Audits</h3>
                            <p>
                              offering smart contract audits at a very
                              reasonable price with security. Easily complete
                              your task with frequent auditing reports.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-lg-6">
                        <div className="dtatas">
                          <span>9</span>
                          <div>
                            <h3>Decentralized Exchange</h3>
                            <p>
                              Our blockchain development team produces
                              hack-proof and powerful decentralized exchange
                              systems on Android and iOS to enable the secure
                              and efficient trading of digital currencies in
                              real-time.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-lg-6">
                        <div className="dtatas">
                          <span>10</span>
                          <div>
                            <h3>Blockchain Wallet Development</h3>
                            <p>
                              Creating safe and secure crypto wallets with hot
                              and cold storage capabilities, allowing for the
                              exchange of various digital assets and currencies.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-lg-12 first_section_crypto d-flex justify-content-center">
                        <Button
                          data-toggle="modal"
                          data-target="#myModal"
                          aria-label="Schedule A Meeting"
                        >
                          Schedule A Meeting
                        </Button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white bg_block_cjahina_newww">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="first_section_crypto">
                      <h2 className="text_ceeenter">
                        Industries that use our Blockchain Solutions
                      </h2>
                      <p className="text-center">
                        Businesses may use blockchain technology to transform
                        their fundamental processes and boost security,
                        trackability, transparency, and immutability. Depending
                        on the nature of the sector, you can modify the
                        blockchain for connected networks. As a result of
                        blockchain development services, some well-known sectors
                        saw drastic transformations
                      </p>
                      <div className="option_list">
                        <ul>
                          <li>Insurance</li>
                          <li>Education</li>
                          <li>Travel & Tourism</li>
                          <li>Gaming</li>
                          <li>E-commerce</li>
                          <li>Supply chain</li>
                          <li>Banking</li>
                          <li>Health Care</li>
                          <li>Logistics and Transportation</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-light bg_imga_CTA_new">
              <div className="container">
                <div className="">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="first_section_crypto ">
                        <h2 className="text_ceeenter">
                          Are you seeking experienced advice? <br />
                          Share your specifications and receive the best
                          quotation for your job
                        </h2>
                        <Button
                          data-toggle="modal"
                          data-target="#myModal"
                          aria-label="Get A Quote"
                          className="box_shadow_non m-auto"
                        >
                          Get A Quote
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white ">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="first_section_crypto">
                      <h2 className="text_ceeenter">
                        Our Blockchain Technology Knowledge
                      </h2>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="smart_content">
                      <h3>Smart Contract</h3>
                      <ul>
                        <li>
                          <img
                            src={require("../../image/new/blockdev/smarttoffle.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Truffle</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/new/blockdev/smartzappline.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Openzappline</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/new/blockdev/smarthardhat.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>HardHat</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/new/blockdev/smart-infura.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Infura</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/new/blockdev/smart-quicknode.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Quicknode</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/new/blockdev/smart-ganache.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Ganache</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/new/blockdev/smart-pinata.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Pinata</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/new/blockdev/smart-metamask.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Metamask</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/new/blockdev/smart-chainlink.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Chainlink</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="smart_content">
                      <h3>Programming Language</h3>
                      <ul>
                        <li>
                          <img
                            src={require("../../image/new/blockdev/prog-solitity.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Solidity</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/new/blockdev/prog-vyper.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Vyper</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/ai/rust_img.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Rust</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/new/blockdev/prog-python.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Python</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/new/blockdev/prog-c.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>C++</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="smart_content">
                      <h3>Framework</h3>
                      <ul>
                        <li>
                          <img
                            src={require("../../image/new/blockdev/frame-node.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Node JS</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/new/blockdev/frame-etherjs.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Ether.JS</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/new/blockdev/frame-web3js.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>web3.JS</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/new/blockdev/Frame-react.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>React.JS</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/new/blockdev/Frame-anguler.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Angular JS</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/new/blockdev/frame-next-js.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Next.JS</p>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="col-lg-12">
                    <div className="smart_content">
                      <h3>DataBase</h3>
                      <ul>
                        <li>
                          <img
                            src={require("../../image/new/blockdev/deta-graph.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>The Graph</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/new/blockdev/data-couchdb.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>CouchDB</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/new/blockdev/data-mongodb.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>MongoDB</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="smart_content">
                      <h3>Wallet</h3>
                      <ul>
                        <li>
                          <img
                            src={require("../../image/ai/binance.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Binance</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/new/blockdev/wallet-trust.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Trust Wallet</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/new/blockdev/smart-metamask.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Metamask</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/new/blockdev/wallet-coinbase.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>Coinbase</p>
                        </li>
                        <li>
                          <img
                            src={require("../../image/new/blockdev/wallet-conetct.webp")}
                            alt="techstack"
                            className=""
                          />
                          <p>WalletConnect</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-light">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="first_section_crypto ">
                      <h2 className="text-center text_center_new">
                        End-to-End process for our Blockchain Development
                      </h2>
                      <div className="processs_img_ads">
                        <img
                          src={EndStep}
                          alt="techstack"
                          className="img-fluid "
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white block_we_work">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="first_section_crypto ">
                      <h2 className="text-center text_center_new">
                        Blockchain Networks We Support
                      </h2>
                      <p className="text-center">
                        Blockchain is a decentralized network that allows users
                        to send transactions and construct apps without the need
                        for a single authority or server. Use our extensive
                        network assistance for you.
                      </p>
                    </div>
                    <ul className="row list_item_d justify-content-center">
                      <li className="col-md-6 col-lg-4">
                        <div className="dtatas fetures_cardwe">
                          <div>
                            <div className="feturt_image">
                              <img
                                src={require("../../image/ai/Ethereum.webp")}
                                alt="techstack"
                                className=""
                              />
                            </div>
                            <h3>Ethereum</h3>
                            <p>
                              The most well-known network for digital asset
                              transfers and the certification of smart
                              contracts.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-md-6 col-lg-4">
                        <div className="dtatas fetures_cardwe">
                          <div>
                            <div className="feturt_image">
                              <img
                                src={require("../../image/ai/Polygon.webp")}
                                alt="techstack"
                                className=""
                              />
                            </div>
                            <h3>Polygon</h3>
                            <p>Easy interoperability reduces network fees</p>
                          </div>
                        </div>
                      </li>
                      <li className="col-md-6 col-lg-4">
                        <div className="dtatas fetures_cardwe">
                          <div>
                            <div className="feturt_image">
                              <img
                                src={require("../../image/ai/car.webp")}
                                alt="techstack"
                                className=""
                              />
                            </div>
                            <h3>Cardano</h3>
                            <p>
                              A highly secure and scalable proof-of-stake (POS)
                              timestamping system
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-md-6 col-lg-4">
                        <div className="dtatas fetures_cardwe">
                          <div>
                            <div className="feturt_image">
                              <img
                                src={require("../../image/ai/red.webp")}
                                alt="techstack"
                                className=""
                              />
                            </div>
                            <h3>Avalanche</h3>
                            <p>
                              The Avalanche protocol enables developers to
                              create unique blockchain networks that span
                              private and permissionless deployments.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-md-6 col-lg-4">
                        <div className="dtatas fetures_cardwe">
                          <div>
                            <div className="feturt_image">
                              <img
                                src={require("../../image/ai/x_img.webp")}
                                alt="techstack"
                                className=""
                              />
                            </div>
                            <h3>Near</h3>
                            <p>
                              Simple, secure and sustainable which uses the
                              multi-chain network to work
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-md-6 col-lg-4">
                        <div className="dtatas fetures_cardwe">
                          <div>
                            <div className="feturt_image">
                              <img
                                src={require("../../image/ai/cross.webp")}
                                alt="techstack"
                                className=""
                              />
                            </div>
                            <h3>Stellar</h3>
                            <p>
                              Stellar is an open platform for building financial
                              products that connect people everywhere.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-md-6 col-lg-4">
                        <div className="dtatas fetures_cardwe">
                          <div>
                            <div className="feturt_image">
                              <img
                                src={require("../../image/new/blockdev/hyperledger-icon.webp")}
                                alt="techstack"
                                className=""
                              />
                            </div>
                            <h3>Hyperledger</h3>
                            <p>
                              An umbrella project of open-source blockchains to
                              build enterprise-grade blockchain apps
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-md-6 col-lg-4">
                        <div className="dtatas fetures_cardwe">
                          <div>
                            <div className="feturt_image">
                              <img
                                src={require("../../image/ai/palko.webp")}
                                alt="techstack"
                                className=""
                              />
                            </div>
                            <h3>Polkadot</h3>
                            <p>
                              Polkadot is an open-source web3 blockchain network
                              for enabling interoperability and
                              interconnectivity.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-md-6 col-lg-4">
                        <div className="dtatas fetures_cardwe">
                          <div>
                            <div className="feturt_image">
                              <img
                                src={require("../../image/new/blockdev/tezos-xtz-logo.webp")}
                                alt="techstack"
                                className=""
                              />
                            </div>
                            <h3>Tezos</h3>
                            <p>
                              An Open-Source Platform for Decentralized Assets
                              and Applications
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-md-6 col-lg-4">
                        <div className="dtatas fetures_cardwe">
                          <div>
                            <div className="feturt_image">
                              <img
                                src={require("../../image/ai/binance.webp")}
                                alt="techstack"
                                className=""
                              />
                            </div>
                            <h3>Binance</h3>
                            <p>
                              Efficient in handling thousands of transactions
                              with a proof-of-history (POH) system
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="col-md-6 col-lg-4">
                        <div className="dtatas fetures_cardwe">
                          <div>
                            <div className="feturt_image">
                              <img
                                src={require("../../image/ai/ct.webp")}
                                alt="techstack"
                                className=""
                              />
                            </div>
                            <h3>EOS</h3>
                            <p>
                              Helps in a high-speed transaction with zero
                              transaction fees
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-light turstss_blss">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="first_section_crypto ">
                      <h2 className="text-center text_center_new">
                        What makes us a trustworthy Blockchain Partner?
                      </h2>
                      <p className="text-center">
                        Beleaf technologies is a leading blockchain development
                        company that provides the finest blockchain solutions to
                        help your business in various sectors. We have a team of
                        blockchain engineers that are well-versed in providing
                        blockchain solutions that meet all of your company
                        requirements.
                      </p>
                    </div>
                    <div className="row">
                      <div className="col-lg-6">
                        <img
                          src={require("../../image/new/blockdev/tusreeee.webp")}
                          alt="techstack"
                          className="markey_place_img"
                        />
                      </div>
                      <div className="col-lg-6">
                        <ul className="list_fetures">
                          <li>Proficient Blockchain Developers</li>
                          <li>Up-to-date Technical support</li>
                          <li>High Security and Transparent</li>
                          <li>Innovative and Custom solutions</li>
                          <li>Modern blockchain development strategy</li>
                          <li>360° Holistic Approach</li>
                        </ul>
                      </div>
                      <div className="col-lg-12 col_CTA_btn">
                        <div className="img_clas_butn first_section_crypto ">
                          <a href="https://wa.me/7904323274">
                            <Button
                            // data-toggle="modal"
                            // data-target="#myModal"
                            // aria-label="Talk To Our Blockchain Experts"
                            >
                              Talk To Our Blockchain Experts
                            </Button>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <Section id="about why new_faq bg_white CEX_faq">
              <section className="section bg_white CEX_faq" id="">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-6 d-flex justify-content-center align-items-center">
                      <div className="whybelaf faq">
                        <h2 className="">
                          Frequently asked <br />
                          Question
                        </h2>
                        <p></p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="comtent">
                        <div id="main">
                          <div className="container">
                            <div className="accordion" id="faq">
                              <div className="card">
                                <div className="card-header" id="faqhead1">
                                  <a
                                    href="#"
                                    className="btn btn-header-link"
                                    data-toggle="collapse"
                                    data-target="#faq1"
                                    aria-expanded="true"
                                    aria-controls="faq1"
                                  >
                                    What Exactly Is Blockchain?
                                  </a>
                                </div>

                                <div
                                  id="faq1"
                                  className="collapse show"
                                  aria-labelledby="faqhead1"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    Blockchain is a fully decentralized and
                                    distributed ledger system that can store
                                    encrypted information that is visible,
                                    unchangeable, and trackable by blockchain
                                    community users. Blockchain technology was
                                    developed to store information about bitcoin
                                    and its transactions, and it is currently
                                    employed in many sectors since it provides
                                    the greatest means to store data better than
                                    any other traditional database.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead2">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq2"
                                    aria-expanded="true"
                                    aria-controls="faq2"
                                  >
                                    How Can Blockchain Be Used in Business?
                                  </a>
                                </div>

                                <div
                                  id="faq2"
                                  className="collapse"
                                  aria-labelledby="faqhead2"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    Because blockchain creates a new form of
                                    data storage and provides high-level
                                    security to those records, businesses and
                                    organizations can leverage this distributed
                                    technology to store, retrieve, and manage
                                    business records under one single roof,
                                    where the data can be fully decentralized,
                                    preventing any third party, including
                                    hackers, from accessing the records.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead3">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq3"
                                    aria-expanded="true"
                                    aria-controls="faq3"
                                  >
                                    Is it possible to hack blockchain?
                                  </a>
                                </div>

                                <div
                                  id="faq3"
                                  className="collapse"
                                  aria-labelledby="faqhead3"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    Blockchain is not entirely hackable and is
                                    not completely transparent to hackers since
                                    data inside a blockchain is encrypted and
                                    visible only to nodes in networks.
                                    Furthermore, if a hacker wishes to modify a
                                    record in a block, each node will be alerted
                                    since each node has jurisdiction over all
                                    blocks and the copy of data has been shared
                                    with all nodes. As a result, the hacker was
                                    unable to hack all of the blogs, and he was
                                    unable to update the record without being
                                    warned by the other nodes.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead4">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq4"
                                    aria-expanded="true"
                                    aria-controls="faq4"
                                  >
                                    What are the advantages of Blockchain
                                    technology?
                                  </a>
                                </div>

                                <div
                                  id="faq4"
                                  className="collapse"
                                  aria-labelledby="faqhead4"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    Blockchain technology has several benefits
                                    for global and local communities when it
                                    comes to global contact. Blockchain
                                    technology enables data synchronization, a
                                    secure platform, tokenization, and built-in
                                    incentivization.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead5">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq5"
                                    aria-expanded="true"
                                    aria-controls="faq5"
                                  >
                                    How much does Blockchain development cost?
                                  </a>
                                </div>

                                <div
                                  id="faq5"
                                  className="collapse"
                                  aria-labelledby="faqhead5"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    Several variables limit the cost assessment
                                    of Blockchain Software development. The type
                                    of business determines the project's cost
                                    estimation. The entire project estimation is
                                    determined by the quantity of data
                                    investigation, the size of the project, and
                                    the customisation choices.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </Section>
          </span>
          {/* <Commonpage /> */}
        </main>
      </div>

      {/* <Footer /> */}
      <ServiceFooter />
    </div>
  );
}

export default Cex;
